<template>
    <div v-show="isModalVisible">
        <transition name="slide">
            <div class="modal-mask" @click="hide">
                <div class="modal-dialog modal-dialog-slideout modal-lg"  @click.stop>
                   <div class="modal-content  p-2">

                        <div class="modal-header">
                             <a href="javascript:void(0);" @click="hide" style="cursor: pointer;" class="text-uppercase text-muted pt-1"><img class="back_icon mr-2" src="@/assets/manager/back_button_icon.png" />Back</a>
                                <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="hide">
                                    <span aria-hidden="true">×</span>
                                </button>          
                        </div>                
                        
                        <div class="modal-body">
                          <div class="maheading_2">
                                <h5 class="modal-title">Billing</h5>
                          </div>  
                          <div class="mt-3 mb-3 py-2 px-3 subscription_box rounded shadow" v-if="unitType == ''">
                            <div class="row">
                              <div class="col-12 text-center">
                                You didn't purchase any subscription!
                              </div>
                              <div class="col-12 text-center pr-2 pt-2" >
                                  <button type="submit" class="btn btn-md ma-blue-btn" @click="openAddSubscriptionListsModal()">Add Subscription</button>
                                </div>
                            </div>
                          </div>
                          <div class="mt-3 mb-3 py-2 px-3 subscription_box rounded shadow" v-if="unitType != ''">
                            <div class="row">
                                <div class="col-8">
                                    {{ packageName }}
                                </div>
                                <div class="col-4 text-right pr-4">
                                    Auto-Renew: 
                                      <label class="switch" style="margin-left: 10px; padding: 0;">
                                        <input type="checkbox" v-model="autoRenewal" @change="openAuthModal($event)" :checked="autoRenewal">
                                        <span class="slider round"></span>
                                      </label>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-8 seat_qty">
                                  <div class="col-12 p-0">
                                    <i>{{ packageQty }}</i>
                                  </div>
                                  <div class="col-12 p-0" v-if="additionalSeat > 1 && packageQty != 'Unlimited Mentee Seats'">
                                    + {{ additionalSeat }} Mentee Seats 
                                  </div>
                                  <div class="col-12 p-0" v-else-if="additionalSeat == 1 && packageQty != 'Unlimited Mentee Seats'">
                                    + {{ additionalSeat }} Mentee Seat 
                                  </div>
                                </div>
                                <div class="col-4 text-right pr-2 pt-1" v-if="unitType == 'Seat' && renewFlag == 1 && pricingAffiliateChange == 1">
                                  <button type="submit" class="btn btn-md ma-blue-btn mb-2" @click="openRenewSeatPricingChangeModal">Renew</button>
                                </div>
                                <div class="col-4 text-right pr-2 pt-1" v-else-if="unitType == 'Seat' && renewFlag == 1 && type == 'yearly'">
                                  <button type="submit" class="btn btn-md ma-blue-btn mb-2" @click="openRenewSeatModal">Renew</button>
                                </div>
                                <div class="col-4 text-right pr-2 pt-1" v-else-if="unitType == 'Seat' && renewFlag == 1 && type == 'monthly'">
                                  <button type="submit" class="btn btn-md ma-blue-btn mb-2" @click="openRenewSeatModal">Renew</button>
                                </div>
                                <div class="col-4 text-right pr-2 pt-1" v-else-if="renewFlag == 1">
                                  <button type="submit" class="btn btn-md ma-blue-btn mb-2" @click="openRenewLicenseModal">Renew</button>
                                </div>
                            </div>
                            <div class="row pt-1">
                                <div class="col-7">
                                    Renewal: {{ renewalDate }}
                                </div>
                                <div class="col-5 text-right pr-2" v-if="unitType == 'Seat' && showUnlimitedAnnualSubscription == 1">


                                  <div class="col-12 p-0 text-right pr-3">
                                    <div class="chkboxwrapper">
                                      <div class="custom-control custom-checkbox">
                                        <input
                                          type="checkbox"
                                          id="annualSubscriptionmp"
                                          name="annualSubscriptionmp"
                                          ref="annualSubscriptionmp"
                                          v-model="annualSubscription"
                                          :checked="annualSubscription" class="custom-control-input" 
                                          @change="clickAnnualSubscriptionmP($event)"
                                          :value="1">
                                        <label class="custom-control-label" for="annualSubscriptionmp">Switch to Annual Billing</label>
                                      </div>
                                    </div>
                                  </div>


                                </div>
                                <div class="col-5 text-right pr-2" v-if="unitType == 'Seat' && type == 'monthly' && accountExpired == 0 && unlimited == false">
                                  <button type="submit" class="btn btn-md ma-blue-btn" @click="openMonthlySubscriptionListsModal()">Edit Subscription</button>
                                </div>
                                <div class="col-5 text-right pr-2" v-else-if="unitType == 'Seat' && accountExpired == 0 && unlimited == false">
                                  <button type="submit" class="btn btn-md ma-blue-btn" @click="openSubscriptionListsModal()">Edit Subscription</button>
                                </div>
                                <div class="col-5 text-right pr-2" v-else>
                                  
                                </div>
                            </div>

                            <div class="clear"></div>
                          </div>
                          <div class="mt-3 mb-3 py-2 px-3 subscription_box rounded shadow">
                            <div class="row">
                                <div class="col-8">
                                  Payment Method
                                </div>
                                <div class="col-4 text-right pr-4">
                                    &nbsp;
                                </div>
                            </div>
                            <div class="row pb-2" v-if="cardName != ''">
                              <div class="col-3 seat_qty pt-1">
                                  {{ cardName }}
                              </div>
                              <div class="col-4  pt-1">
                                  {{ cardNo }}
                              </div>
                              <div class="col-2 pt-1">
                                  {{ cardExpire }}
                              </div>
                              <div class="col-3 text-right pr-2">
                                  <button type="submit" class="btn btn-md ma-blue-btn" @click="openPaymentListsModal">Edit</button>
                              </div>
                            </div>
                            <div class="row pb-2" v-else>
                              <div class="col-12 seat_qty text-center">
                                <i>No Payment Method found!</i>
                              </div>
                              <div class="col-12 text-center pt-2">
                                <button type="submit" class="btn btn-md ma-blue-btn" @click="openNewPaymentMethodModal()">Add New Payment Method</button>
                              </div>
                            </div>
                            <div class="clear"></div>
                          </div>




                    <div class="db-card mentor-panel-wrapper pt-4">
                      <div class="col-12 p-0">
                        <h5 class="title" style="font-size: 20px !important;">Renewal</h5>
                      </div>
                      <div class="col-12 p-0">
                        <div class="receipt-heading-1 receipt-heading ">
                          Date
                        </div>
                        <div class="receipt-heading-2 receipt-heading text-center ">
                          Invoice
                        </div>
                        <div class="receipt-heading-3 receipt-heading ">
                          Subscription
                        </div>
                        <div class="receipt-heading-4 receipt-heading  ">
                          Total
                        </div>                      
                        <div class="receipt-heading-6 receipt-heading text-center ">
                          Renews
                        </div>
                      </div>

                      <div class="pt-2" v-if="purchaseLoading == true">
                        <div class="row" v-for="option in 5">
                          <div class="receipt-heading-1 pr-2 pl-2"><PuSkeleton :count="1"></PuSkeleton></div>
                          <div class="receipt-heading-2 pr-2"><PuSkeleton :count="1"></PuSkeleton></div>
                          <div class="receipt-heading-3 pr-2"><PuSkeleton :count="1"></PuSkeleton></div>
                          <div class="receipt-heading-4 pr-2"><PuSkeleton :count="1"></PuSkeleton></div>
                          <div class="receipt-heading-6 pr-2"><PuSkeleton :count="1"></PuSkeleton></div>
                          <div class="col-12 p-0">
                            <div class="custom_hr"></div>
                          </div>
                        </div>
                      </div>

                      <div v-if="orderItems.length > 0 && purchaseLoading == false">
                      <div class="col-12 p-0" v-for="(order, index) in renewalItems">
                        <div class="receipt-heading-1 receipt">
                          {{ order.date }}
                        </div>
                        <div class="receipt-heading-2 receipt text-center">
                          <a href="javascript:void(0);" class="invoice_link branding_text_color" @click="getInvoicePdf(order)">{{ order.invoiceNo }}</a>
                        </div>
                        <div class="receipt-heading-3 receipt">
                          {{ order.noOfUnits }}
                        </div>
                        <div class="receipt-heading-4 receipt ">
                          &#36;{{ order.totalAmount }} 
                        </div>                      
                        <div class="receipt-heading-6 receipt text-center" >
                          {{ order.renewal }}
                        </div>
                        <div style="clear: both;"></div>
                      </div>
                      </div>
                      <div v-if="renewalItems.length == 0 && purchaseLoading == false">
                        <div class="col-12 p-0 receipt">
                          No Orders Found.
                        </div>
                      </div>
                      <div style="clear: both; "></div>
                    </div>


                    <div class="db-card mentor-panel-wrapper pt-4">
                      <div class="col-12 p-0">
                        <h5 class="title" style="font-size: 20px !important;">Purchase History</h5>
                      </div>
                      <div class="col-12 p-0">
                        <div class="receipt-heading-1-1 receipt-heading ">
                          Date
                        </div>
                        <div class="receipt-heading-6-1 receipt-heading ">
                          Payment Method
                        </div>
                        <div class="receipt-heading-2-1 receipt-heading text-center ">
                          Receipt
                        </div>
                        <div class="receipt-heading-3-1 receipt-heading ">
                          Purchase
                        </div>
                        <div class="receipt-heading-4-1 receipt-heading  ">
                          Total
                        </div>                      
                        <div class="receipt-heading-6 receipt-heading text-center ">
                          Status
                        </div>
                      </div>

                      <div class="pt-2" v-if="purchaseLoading == true">
                        <div class="row" v-for="option in 5">
                          <div class="receipt-heading-1-1 pr-2 pl-2"><PuSkeleton :count="1"></PuSkeleton></div>
                          <div class="receipt-heading-6-1 pr-2"><PuSkeleton :count="1"></PuSkeleton></div>
                          <div class="receipt-heading-2-1 pr-2"><PuSkeleton :count="1"></PuSkeleton></div>
                          <div class="receipt-heading-3-1 pr-2"><PuSkeleton :count="1"></PuSkeleton></div>
                          <div class="receipt-heading-4-1 pr-2"><PuSkeleton :count="1"></PuSkeleton></div>
                          <div class="receipt-heading-6 pr-2"><PuSkeleton :count="1"></PuSkeleton></div>
                          <div class="col-12 p-0">
                            <div class="custom_hr"></div>
                          </div>
                        </div>
                      </div>

                      <div v-if="orderItems.length > 0 && purchaseLoading == false">
                      <div class="col-12 p-0" v-for="(order, index) in orderItems">
                        <div class="receipt-heading-1-1 receipt">
                          {{ order.date }}
                        </div>
                        <div class="receipt-heading-6-1 receipt" style="text-transform: capitalize;">
                          {{ order.paymentMethod }}
                        </div>
                        <div class="receipt-heading-2-1 receipt text-center" v-if="order.isMonthlyBilling == 1">
                          <a href="javascript:void(0);" class="invoice_link branding_text_color" @click="getMonthlyInvoicePdf(order)">{{ order.invoiceNo }}</a>
                        </div>
                        <div class="receipt-heading-2-1 receipt text-center" v-else>
                          <a href="javascript:void(0);" class="invoice_link branding_text_color" @click="getInvoicePdf(order)">{{ order.invoiceNo }}</a>
                        </div>
                        <div class="receipt-heading-3-1 receipt">
                          {{ order.noOfUnits }}
                        </div>
                        <div class="receipt-heading-4-1 receipt ">
                          &#36;{{ order.totalAmount }} 
                        </div>                      
                        <div class="receipt-heading-6 receipt text-center" v-if="order.paymentStatus != 'Due' && order.isMonthlyBilling == 1">
                          {{ order.paymentStatus }} <a href="javascript:void(0);" class="invoice_link" @click="getMonthlyInvoicePdf(order)"><img class="cursor-pointer" src="@/assets/Download_Report.svg" alt="MentorMentee" width="12px"  /></a>
                        </div>
                        <div class="receipt-heading-6 receipt text-center" v-else-if="order.paymentStatus != 'Due'">
                          {{ order.paymentStatus }} <a href="javascript:void(0);" class="invoice_link" @click="getInvoicePdf(order)"><img class="cursor-pointer" src="@/assets/Download_Report.svg" alt="MentorMentee" width="12px"  /></a>
                        </div>
                        <div class="receipt-heading-6 receipt text-center" v-else-if="(order.paymentStatus == 'Due' && order.paymentMethod == 'credit card')">
                          <button type="submit" class="btn btn-md ma-blue-btn" style="font-size: 10px; width: 60px; padding: 2px 5px 2px 6px; border-radius: 5px;" @click="openProcessPaymentModal(order.orderId)">Process</button>
                        </div>
                        <div class="receipt-heading-6 receipt text-center" v-else>
                          {{ order.paymentStatus }}
                        </div>
                        <div style="clear: both;"></div>
                      </div>
                      </div>
                      <div v-if="orderItems.length == 0 && purchaseLoading == false">
                        <div class="col-12 p-0 receipt">
                          No Orders Found.
                        </div>
                      </div>
                      <div style="clear: both; "></div>
                    </div>



                        </div>
                        <div class="modal-footer mb-5"></div>
                    </div>
                </div>
            </div>
        </transition>

        <NewPaymentMethod
          :isModalVisible="isNewPaymentMethodModalVisible"
          ref="NewPaymentMethodModal"
          @close="isNewPaymentMethodModalVisible = false">
        </NewPaymentMethod>

        <PaymentLists
          :isModalVisible="isPaymentListsModalVisible"
          ref="PaymentListsModal"
          @close="isPaymentListsModalVisible = false">
        </PaymentLists>

        <MonthlySubscriptionLists
          :isModalVisible="isMonthlySubscriptionListsModalVisible"
          ref="MonthlySubscriptionListsModal"
          @close="isMonthlySubscriptionListsModalVisible = false">
        </MonthlySubscriptionLists>

        <SubscriptionLists
          :isModalVisible="isSubscriptionListsModalVisible"
          ref="SubscriptionListsModal"
          @close="isSubscriptionListsModalVisible = false">
        </SubscriptionLists>

        <ProcessPayment
          :isModalVisible="isProcessPaymentModalVisible"
          ref="ProcessPaymentModal"
          @close="closeProcessPaymentModal">
        </ProcessPayment>

        <RenewSeat
          :isModalVisible="isRenewSeatModalVisible"
          :type="type"
          ref="RenewSeatModal"
          @close="isRenewSeatModalVisible = false">
        </RenewSeat>

        <RenewLicense
          :isModalVisible="isRenewLicenseModalVisible"
          ref="RenewLicenseModal"
          @close="isRenewLicenseModalVisible = false">
        </RenewLicense>

        <AddSubscription
          :isModalVisible="isAddSubscriptionModalVisible"
          ref="AddSubscriptionModal"
          @close="isAddSubscriptionModalVisible = false">
        </AddSubscription>

        <RenewSeatPricingAffiliate
          :isModalVisible="isRenewSeatPricingAffiliateModalVisible"
          :type="type"
          ref="RenewSeatPricingAffiliateModal"
          @close="isRenewSeatPricingAffiliateModalVisible = false">
        </RenewSeatPricingAffiliate>

        <SubscriptionReview
          :isModalVisible="isSubscriptionReviewModalVisible"
          :packageId="packageId"
          :purchaseType="purchaseType"
          annualSubscription="true"
          ref="SubscriptionReviewModal"
          @close="isSubscriptionReviewModalVisible = false">
        </SubscriptionReview>

  
    </div>
  </div>

</template>
<script>
import Vue from 'vue/dist/vue.esm';
import router from '../../router/index.js';
import axios from 'axios';
import VeeValidate from 'vee-validate';
import moment from 'moment';
import { BPopover } from 'bootstrap-vue'
Vue.component('b-popover', BPopover)


import NewPaymentMethod from './new_payment_method.vue';
import PaymentLists from './payment_method_lists.vue';
import ProcessPayment from './process_payment.vue';
import SubscriptionLists from './subscriptionlists.vue';
import MonthlySubscriptionLists from './subscriptionlists_monthly.vue';
import RenewSeat from './Renewsubscription.vue';
import RenewSeatPricingAffiliate from './RenewSubscriptionlists_changedpricingaffiliate.vue';
import RenewLicense from './renew_license.vue';
import AddSubscription from './add_subscription.vue';
import SubscriptionReview from './subscriptionReview.vue';

Vue.filter('formatExpirationDate', function(value) {
  if (value) {
    return moment(String(value)).format('MMMM DD, YYYY')
  }
});

Vue.use(VeeValidate, { errorBagName: 'verrors', fieldsBagName: 'vfields'});

export default {
    props: ['isModalVisible'],
    data() {
        return {
            loading: false,
            subscriptions: [],
            unitType: '',
            packageName: '',
            packageQty: 0,
            autoRenewal: '',
            renewalDate: '',
            additionalSeat: 0,
            cardName: '',
            cardNo: '',
            cardExpire: '',
            isNewPaymentMethodModalVisible: false,
            isPaymentListsModalVisible: false,
            orderItems: [],
            purchaseLoading: false,
            isProcessPaymentModalVisible: false,
            isSubscriptionListsModalVisible: false,
            isMonthlySubscriptionListsModalVisible: false,
            isRenewLicenseModalVisible: false,
            isRenewSeatModalVisible: false,
            renewFlag: 0,
            renewalItems: [],
            type: '',
            isAddSubscriptionModalVisible: false,
            accountExpired: 0,
            pricingAffiliateChange: 0,
            isRenewSeatPricingAffiliateModalVisible: false,
            isSubscriptionReviewModalVisible: false,
            purchaseType: '',
            annualSubscription: false,
            packageId: '',
            showUnlimitedAnnualSubscription: 0,
            unlimited: false,

        }
    },
    components: {
      NewPaymentMethod,
      PaymentLists,
      ProcessPayment,
      SubscriptionLists,
      RenewSeat,
      RenewLicense,
      MonthlySubscriptionLists,
      AddSubscription,
      RenewSeatPricingAffiliate,
      SubscriptionReview,
    },
    methods: {       
        hide() { 
            this.$emit('close');
        },
        clickAnnualSubscriptionmP(event) {
          if(event.target.checked == true) {
            this.annualSubscription = true;
            this.isSubscriptionReviewModalVisible = true;
            this.$refs.SubscriptionReviewModal.loadInitialData1(this.annualSubscription);
          }
          else {
            this.annualSubscription = false;
          }
        },
        openRenewSeatPricingChangeModal() {
         this.isRenewSeatPricingAffiliateModalVisible = true;
         this.$refs.RenewSeatPricingAffiliateModal.loadInitialData();
        },
        closeAddSubscriptionListsModal() {
          this.isAddSubscriptionModalVisible = false;
          this.loadInitialData();
        },
        openAddSubscriptionListsModal() {
          this.isAddSubscriptionModalVisible = true;
          this.$refs.AddSubscriptionModal.loadInitialData();
        },
        openAuthModal(event) {
          axios('/update-auto-renewal',
          {
              method: 'POST', 
              data: {
                  "accountId": this.$store.state.user_accountid,
                  "autoRenewal": this.autoRenewal,
              }
          })
          .then(response => {                
              
          })
          .catch(error => {

          });
        },
        openRenewLicenseModal() {
         this.isRenewLicenseModalVisible = true;
         this.$refs.RenewLicenseModal.loadInitialData();
        },
        openRenewSeatModal() {
         this.isRenewSeatModalVisible = true;
         this.$refs.RenewSeatModal.loadInitialData();
        },
        openProcessPaymentModal(orderId) {
         this.isProcessPaymentModalVisible = true;
         this.$refs.ProcessPaymentModal.loadInitialData(orderId);
        },
        closeProcessPaymentModal(orderId) {
         this.isProcessPaymentModalVisible = false;
        },
        openMonthlySubscriptionListsModal() {
          this.isMonthlySubscriptionListsModalVisible = true;
          this.$refs.MonthlySubscriptionListsModal.loadInitialData();
        },
        openSubscriptionListsModal() {
          this.isSubscriptionListsModalVisible = true;
          this.$refs.SubscriptionListsModal.loadInitialData();
        },
        openNewPaymentMethodModal() {
          this.isNewPaymentMethodModalVisible = true;
          this.$refs.NewPaymentMethodModal.loadInitialData();
        },
        openPaymentListsModal() {
          this.isPaymentListsModalVisible = true;
          this.$refs.PaymentListsModal.loadInitialData();
        },
        closePaymentMethod() {
          this.isNewPaymentMethodModalVisible = false;
          this.getPrimaryPaymentDetails();
        },
        closePaymentMethodLists() { 
          this.isPaymentListsModalVisible = false;
          this.getPrimaryPaymentDetails();
        },
        close() {
            this.verrors.clear();
            if (this.close_url) {
                let routeData = this.$router.resolve({name: this.close_url});
                window.open(routeData.href, '_self');
            } else {
                let routeData = this.$router.resolve({name: 'managelicense'});              
                window.open(routeData.href, '_self');                
            }
        },
        onClose() {
          this.popoverShow = false
        },
        getOrderItems: function() {
          this.purchaseLoading = true;
          axios('/desktop/manager-orders/' + this.$store.state.user_accountid,
          {
            method: 'GET',
          })
          .then(resp => {
            this.purchaseLoading = false;
            this.orderItems = resp.data.orderItems;
            this.renewalItems = resp.data.renewalItems;
            
          })
          .catch(() => {
          });

        },

        getMonthlyInvoicePdf(item) {
          let pdfEndPoint;
          pdfEndPoint = '/getMonthlyOrderInvoicePdf';
          axios(pdfEndPoint,
            {
              method: 'POST',
              data: {
                  "orderId": item.orderId,
                  "accountId": this.$store.state.user_accountid,
              }
            },
          )
          .then(response => {
            window.open(response.data.invoice_filepath, '_blank');
          })
          .catch(error => {
            console.log(error)
          });
        },


        getInvoicePdf(item) {
          let pdfEndPoint;
          pdfEndPoint = '/getOrderInvoicePdf';
          axios(pdfEndPoint,
            {
              method: 'POST',
              data: {
                  "billing": {
                      "billing_name": item.billingName,
                      "billing_address": item.address,
                      "billing_address2": item.address2,
                      "billing_city": item.city,
                      "billing_country": item.countryCode,
                      "billing_phone": item.phoneNumber,
                      "billing_state": item.stateCode,
                      "billing_zip": item.zipCode,
                      "billing_primary_admin": item.billingPrimaryAdmin
                  },
                  "orderId": item.orderId
              }
            },
          )
          .then(response => {
            window.open(response.data.invoice_filepath, '_blank');
          })
          .catch(error => {
            console.log(error)
          });
        },

        getPrimaryPaymentDetails() {

          axios('/desktop/get-payment-details/'+ this.$store.state.user_accountid,
          {
            method: 'GET'        
          })
          .then(resp => {        
            this.cardName = resp.data.cardName;
            this.cardNo = resp.data.cardNo;
            this.cardExpire = resp.data.cardExpire;

          })
          .catch(() => {
          });      

        },
        getSubscriptionDetails() {

          axios('/desktop/get-account-subscription/'+ this.$store.state.user_accountid,
          {
            method: 'GET'        
          })
          .then(resp => {        
            this.unitType = resp.data.unitType;
            this.packageName = resp.data.packageName;
            this.packageQty = resp.data.packageQty;
            this.autoRenewal = resp.data.autoRenewal;
            this.renewFlag = resp.data.renewFlag;
            this.type = resp.data.type;
            this.renewalDate = resp.data.renewalDate;
            this.additionalSeat = resp.data.additionalSeat;     
            this.accountExpired = resp.data.accountExpired;  
            this.pricingAffiliateChange = resp.data.pricingAffiliateChange;   
            this.showUnlimitedAnnualSubscription = resp.data.showUnlimitedAnnualSubscription; 
            this.packageId = resp.data.packageId; 
            this.unlimited = resp.data.unlimited; 
          })
          .catch(() => {
          });      

        },
        loadInitialData() {
            this.getSubscriptionDetails();
            this.getPrimaryPaymentDetails();
            this.getOrderItems();
        },
    },
    created() {

    }   
}
</script>
<style scoped>
.back_icon { width: 14px; }
::-webkit-scrollbar {
    width: 0;  /* Remove scrollbar space */
    background: transparent;  /* Optional: just make scrollbar invisible */
}
.modal-mask {
    position: fixed;
    z-index: 1001;
    top: 59px;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    transition: opacity .3s ease;
    overflow-y: scroll;
}
.modal-dialog {
  animation: slide-in 1s forwards;
  -webkit-animation: slide-in 1s forwards;
}

@keyframes slide-in {
  0% {
    -webkit-transform: translateX(100%);
  }
  100% {
    -webkit-transform: translateX(0%);
  }
}

@-webkit-keyframes slide-in {
  0% {
    transform: translateX(100%);
  }
  100% {
    transform: translateX(0%);
  }
}
.modal-dialog {
  max-width: 90%;
}
@media (min-width: 992px) {
    .modal-lg, .modal-xl { width: 700px; }
}
@media (max-width: 576px){ 
    .modal-dialog.modal-dialog-slideout { width: 80% }
}
.modal-dialog-slideout {
    min-height: 100%; margin: 0 0 0 auto; background: #fff; 
}
.modal-dialog-slideout .modal-content{ border: 0; }
.modal-header { border-bottom: none; }
.modal-footer { border-top: none; }
.modal-goback { font-size: 24px; margin: 5px 10px 0 0; cursor: pointer; }
.modal-title { font-weight: 900; }
.modal-body { padding: 0rem 1.5rem 0rem 1.5rem; overflow: auto;}
.maheading_1 { width: 5%; }
.maheading_2 { width: 75%; }
.maheading_3 { width: 20%; }
.rounded {
    border-radius: 10px !important;
    padding: 20px;
    border: 1px solid #B8B7B8;
}
.seat_qty {
    font-size: 13px;
}
.receipt-heading {
  float: left;
  font-weight: normal;
  font-size: 14px;
  text-decoration: underline;
}
.receipt-heading-1{
  width: 18%;
}
.receipt-heading-4 {
  width: 22%;
  text-align: right;
}
.receipt-heading-3 {
  width: 30%; 
}
.receipt-heading-6 {
  width: 12%; 
}
.receipt-heading-2 {
  width: 18%;
}
.receipt-heading-1-1 {
  width: 15%;
}
.receipt-heading-6-1 {
  width: 18%;
}
.receipt-heading-2-1 {
  width: 15%;
}
.receipt-heading-3-1 {
  width: 22%; 
}
.receipt-heading-4-1 {
  width: 18%;
  text-align: right;
}
.receipt {
  font-weight: normal;
  text-decoration: none;
  float: left;
  font-size: 13px;
  padding-top: 8px;
}
.switch {
  position: relative;
  display: inline-block;
  width: 36px;
  height: 20px;

}

.switch input { 
  opacity: 0;
  width: 0;
  height: 0;

}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0px;
  right: 0;
  bottom: 0;
  -webkit-transition: .4s;
  transition: .4s;
  background-color: #808080;
}

.slider:before {
  position: absolute;
  content: "";
  height: 16px;
  width: 16px;
  left: 4px;
  bottom: 2px;
  -webkit-transition: .4s;
  transition: .4s;
  background-color: #FFF;
}

input:checked + .slider {
  background-color: #4E8D23;
}
input:checked + .slider:before {
  background-color: #FFF;
}

input:focus + .slider {
  box-shadow: 0 0 1px #2196F3;
}

input:checked + .slider:before {
  -webkit-transform: translateX(12px);
  -ms-transform: translateX(12px);
  transform: translateX(12px);
}

.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}

</style>




// WEBPACK FOOTER //
// src/components/manager/subscription.vue